import { api } from '../api';
import type { UserProfile } from '../types';

export const getUserProfile = (uid: string) => api.users.get(uid);
export const getMultipleUserProfiles = (uids: string[]) => api.users.getMultiple(uids);
export const updateDisplayName = (uid: string, name: string) => api.users.updateDisplayName(uid, name);
export const updateUserProfile = (uid: string, data: Partial<UserProfile>) => api.users.updateProfile(uid, data);
